import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { AuthService } from './auth.service';

const PUBLIC_AUTH_PATHS = ['/api/auth/', '/api/quotes/', '/api/config/'];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const auth = inject(AuthService);

  return next(req.clone({ withCredentials: true })).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401) {
        return throwError(() => error);
      }

      const url = error.url ?? req.url;
      if (PUBLIC_AUTH_PATHS.some((p) => url.includes(p))) {
        return throwError(() => error);
      }

      auth.logout();

      const onLogin = router.url.startsWith('/login');
      if (!onLogin) {
        const returnUrl = router.url && router.url !== '/' ? router.url : undefined;
        router.navigate(['/login'], returnUrl ? { queryParams: { returnUrl } } : undefined);
      }

      return throwError(() => error);
    }),
  );
};
